// src/utils/registerSW.ts
// PWA service worker registracija + install prompt helpers.

import { isMobileApp } from './mobileBridge';

export function registerServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  // FIX: iOS WKWebView (native app) NE podržava Service Worker pravilno.
  // 'serviceWorker' in navigator vraća lažno true; register() puca i fetch
  // interceptor obara mrežne pozive → app se smrzne. Preskoči SW u native app-i.
  // Browser i instalirana PWA (homescreen) nisu pogođeni — tamo isMobileApp() = false.
  if (isMobileApp()) {
    console.log('[PWA] Native WebView — preskačem Service Worker registraciju');
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('[PWA] Service Worker registered:', registration.scope);

        // Provjera update odmah + svakih 60 minuta dok je app otvorena
        registration.update().catch(() => {});
        setInterval(() => {
          registration.update().catch(() => {});
        }, 60 * 60 * 1000);

        // Notify kad ima nova verzija — skipWaiting da novi SW preuzme
        // (activate već briše stare CACHE_NAME). Ne forciramo reload tokom playbacka.
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[PWA] New version available — activating');
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[PWA] Service Worker registration failed:', err);
      });
  });
}

// Helper: provjeri da li je app instalirana kao PWA
export function isPWAInstalled(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

// Install prompt — Chrome/Android samo
type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

let deferredInstallPrompt: BeforeInstallPromptEvent | null = null;

export function setupInstallPrompt(): void {
  if (typeof window === 'undefined') return;
  // PWA install prompt nema smisla u native WebView (app je već instalirana
  // kao native). isMobileApp() = true → ne registruj listener.
  if (isMobileApp()) return;

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredInstallPrompt = e as BeforeInstallPromptEvent;
    console.log('[PWA] Install prompt ready');
  });
}

export async function showInstallPrompt(): Promise<boolean> {
  if (!deferredInstallPrompt) return false;

  await deferredInstallPrompt.prompt();
  const { outcome } = await deferredInstallPrompt.userChoice;
  deferredInstallPrompt = null;

  return outcome === 'accepted';
}
